export default "__VITE_ASSET__Dm5Zunbp__"